module.exports = __webpack_public_path__ + "img/logo.7a4a7eda.png";